import ActiveItemDetails from 'components/active-item/ActiveItemDetails';
import ActiveItemProperties from 'components/active-item/ActiveItemProperties';
import useActiveItem from 'hooks/useActiveItem';
import useProfile from 'hooks/useProfile';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

const MakeOfferCreate = ({ nextStep, closeWindow, offerData, setOfferData }) => {
  const { pathname } = useLocation();
  const {amount, days, hours} = offerData;
  const {balance} = useProfile();
  const {activeItem} = useActiveItem();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  const isDisabledSubmitCheck = () => {
    setIsSubmitDisabled(
      (amount === null || amount === 0)
      ||
      (
        (days !== null || days !== 0) && hours === null
      )
      ||
      (
        (hours !== null || hours !== 0) && days === null
      )
      ||
      (days === 0 && hours === 0)
    );
};

  const onInputHandler = (e, max) => {
    const { name, value } = e.target;

    let cleanedValue = value.replace(/[^0-9.,]/g, '');

    if (name === 'amount') {
      const decimalParts = cleanedValue.split(/[,\.]/);
      if (decimalParts.length > 2 || (decimalParts.length === 2 && decimalParts[1].length > 2)) {
        return;
      }
    }


    if (cleanedValue === '') {
      setOfferData((prevData) => ({
        ...prevData,
        [name]: null
      }));
      return;
    }


    const numericValue = Number(cleanedValue.replace(',', '.'));


    if (numericValue > max) {
      setOfferData((prevData) => ({
        ...prevData,
        [name]: max
      }));
      return;
    }


    setOfferData((prevData) => ({
      ...prevData,
      [name]: numericValue
    }));
  };

  useEffect(() => {
    isDisabledSubmitCheck();
  }, [offerData]);

  return (
    <section className="make-offer" onClick={(e) => e.stopPropagation()}>
      <section className="make-offer__details">
        <ActiveItemDetails
          pathname={pathname}
          name={activeItem.name}
          img={activeItem.image}
          packType={activeItem.pack_type}
          tag={activeItem.tag}
          type={activeItem.type}
          properties={activeItem.properties}
        />
        <ActiveItemProperties properties={activeItem.properties} />
      </section>
      <section className="make-offer__info">
        <header className="make-offer__header">
          <h2 className="make-offer__title">Make an Offer</h2>
          <button className="make-offer__close" onClick={closeWindow}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </button>
        </header>
        <p className="make-offer__balance">
          <span>Your account balance is:</span>
          <b>{`$${balance} USD`}</b>
        </p>
        <form className="make-offer__form">
          <div className="make-offer__form-row">
            <label>Your offer</label>
            <p className="make-offer__input-wrapper">
              <input type="number" name='amount' onInput={(e) => onInputHandler(e, Infinity)} placeholder="Offer value" value={amount} />
              <span>USD</span>
            </p>
          </div>
          <div className="make-offer__form-row make-offer__form-row--double">
            <label>Offer valid for</label>
            <p className="make-offer__input-wrapper">
              <input type="text" name="days" onInput={(e) => onInputHandler(e, 30)} placeholder="0-30" value={days} />
              <span>DAYS</span>
              <i>Max 30 days</i>
            </p>
            <p className="make-offer__input-wrapper">
              <input type="text" name="hours" onInput={(e) => onInputHandler(e, 23)} placeholder="0-23" value={hours} />
              <span>HOURS</span>
              <i>Max 23 hours</i>
            </p>
          </div>

          <p className='make-offer__form-hint'>
            <span>Seller may receive multiple offers and may accept any offer submitted, regardless of the order in which the offer was received</span>
          </p>

          <button
            type="button"
            className="make-offer__form-submit"
            disabled={isSubmitDisabled}
            onClick={nextStep}
          >
            Continue
          </button>
        </form>
      </section>
    </section>
  )
}

export default MakeOfferCreate;
